import { render, staticRenderFns } from "./EditPriceArea.vue?vue&type=template&id=13c68122&"
import script from "./EditPriceArea.vue?vue&type=script&lang=js&"
export * from "./EditPriceArea.vue?vue&type=script&lang=js&"
import style0 from "./EditPriceArea.vue?vue&type=style&index=0&id=13c68122&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports